import {
  DefaultRewardCalendar,
  ERewardCalendarInternalViewModel
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultRewardCalendar: BlockMetadata = {
  id: ERewardCalendarInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/reward-calendar/default_popup.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: DefaultRewardCalendar
};

export const rewardCalendarDesigns = {
  defaultRewardCalendar
};

export const rewardCalendarDesignsByTheme: Record<EThemes, BlockMetadata[]> =
  Object.values(rewardCalendarDesigns).reduce(
    (acc, design) => {
      if (!acc[design.theme]) {
        acc[design.theme] = [];
      }
      acc[design.theme].push(design);
      return acc;
    },
    {} as Record<EThemes, BlockMetadata[]>
  );
